/**
 * Chi vede la console di piattaforma, e chi vede il gestionale.
 *
 * [sc-48497 / task 48534] Sono due applicazioni diverse dentro la stessa: il
 * cliente lavora nel proprio gestionale, l'amministratore di crmstart guarda i
 * numeri di tutti senza entrare nei dati di nessuno. Da questa task l'API glielo
 * impedisce davvero — `requireTenant` lo rifiuta — quindi una schermata del
 * gestionale, per lui, sarebbe solo una sequenza di errori rossi.
 *
 * Logica pura, come `setupGate.js` e `listiniCategories.js`: riceve quel che
 * serve, restituisce il nome di una rotta o `null`. Una guardia che si può
 * provare da sola è una guardia che non si rompe in silenzio.
 */

/** Rotta d'ingresso della console. */
export const PLATFORM_ROUTE = "piattaforma";

/**
 * È l'amministratore di crmstart?
 *
 * Serve `isAdmin` **e** nessuna azienda: ogni cliente ha il proprio
 * amministratore, e confondere i due vorrebbe dire mostrargli i numeri di tutti.
 * Il confronto con `null` è stretto di proposito, come nel cancello della
 * configurazione: un `companyId` assente è una risposta incompleta, non un
 * amministratore di piattaforma.
 */
export function isPlatformAdmin(user) {
  return Boolean(user?.isAdmin) && user?.companyId === null;
}

/**
 * Dirotta chi si trova dalla parte sbagliata.
 *
 * @param {object} ctx
 * @param {boolean} ctx.authenticated se esiste una sessione valida
 * @param {{isAdmin?: boolean, companyId?: number|null}|null} ctx.user
 * @param {boolean} ctx.isPlatformRoute se la destinazione è dentro la console
 * @returns {string|null} nome della rotta su cui dirottare, oppure null
 */
export function platformRedirectFor({ authenticated, user, isPlatformRoute }) {
  if (!authenticated) return null;

  const platform = isPlatformAdmin(user);

  // L'amministratore di crmstart nel gestionale non ci va: non ha un'azienda, e
  // ogni chiamata ai dati gli risponderebbe 403.
  if (platform && !isPlatformRoute) return PLATFORM_ROUTE;

  // E il cliente nella console nemmeno: lì ci sono i numeri degli altri.
  if (!platform && isPlatformRoute) return "home";

  return null;
}

export default platformRedirectFor;
